import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { OrbScene } from '../../../AvatarPage/scene';
import './LaptopHero.scss';

const LaptopHero: React.FC = () => {
  const orbCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = orbCanvasRef.current;
    if (!canvas) return;
    const orb = new OrbScene();
    orb.init(canvas, { bgColor: '#111111', showCord: true });
    return () => orb.dispose();
  }, []);
  const windows = [
    {
      id: 'notes',
      title: 'Notes',
      initialX: -300,
      finalX: '6%',
      finalY: '10%',
      width: '30%',
      height: '58%',
      delay: 0.8,
    },
    {
      id: 'browser',
      title: 'Browser',
      initialX: 300,
      finalX: '38%',
      finalY: '25%',
      width: '35%',
      height: '55%',
      delay: 0.8,
    },
    {
      id: 'tasks',
      title: 'Tasks',
      initialX: -300,
      finalX: '20%',
      finalY: '45%',
      width: '28%',
      height: '45%',
      delay: 0.8,
    },
  ];

  return (
    <>
    <div className="laptop-hero-container">

      {/* Screen content - over laptop frame */}
      <div className="laptop-hero-screen">
        {/* Background wallpaper */}
        <div className="laptop-hero-screen-wallpaper">
          <img 
            src="https://river-marketing-content.s3.us-east-1.amazonaws.com/landing-pages/riveronboardingbg.webp" 
            alt="Desktop"
            loading="eager"
          />
        </div>

        {/* Animated windows */}
        {windows.map((window) => (
          <motion.div
            key={window.id}
            className="laptop-hero-app-window"
            style={{
              left: window.finalX,
              top: window.finalY,
              width: window.width,
              height: window.height,
            }}
            initial={{
              opacity: 0,
              x: window.initialX,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.7,
              delay: window.delay,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            <div className="laptop-hero-window-header">
              <div className="laptop-hero-window-title">{window.title}</div>
            </div>
            <div className="laptop-hero-window-content">
              <div className="laptop-hero-window-placeholder">
                {window.title === 'Notes' ? (
                  <>
                    <div className="laptop-hero-placeholder-line"></div>
                    <div className="laptop-hero-placeholder-line short"></div>
                    <div className="laptop-hero-placeholder-line"></div>
                  </>
                ) : window.title === 'Tasks' ? (
                  <>
                    <div className="laptop-hero-placeholder-line short"></div>
                    <div className="laptop-hero-placeholder-line"></div>
                    <div className="laptop-hero-placeholder-line short"></div>
                  </>
                ) : (
                  <div className="laptop-hero-browser-bar"></div>
                )}
              </div>
            </div>
          </motion.div>
        ))}

        {/* AI Chat Panel sliding from right */}
        <motion.div
          className="laptop-hero-ai-chat-panel"
          initial={{
            opacity: 0,
            x: 100,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1.0,
            delay: 1.5,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          <div className="laptop-hero-chat-header">
            <div className="laptop-hero-chat-avatar">AI</div>
            <span className="laptop-hero-chat-title">AI Assistant</span>
          </div>
          <div className="laptop-hero-chat-messages">
            <div className="laptop-hero-chat-message">
              <div className="laptop-hero-message-bubble">
                How can I help you today?
              </div>
            </div>
          </div>
          <div className="laptop-hero-chat-input">
            <div className="laptop-hero-input-placeholder">Ask anything...</div>
          </div>
        </motion.div>
      </div>
      {/* MacBook frame SVG - on bottom */}
      <div className="laptop-hero-frame">
        <img 
          src="/landing-pages/personalAI/MacBookPro.svg" 
          alt="MacBook Pro"
          loading="eager"
        />
      </div>
    </div>

    {/* Orb + umbilical cord */}
    <div className="orb-umbilical-wrapper">
      {/* Three.js canvas — orb + cord rendered together */}
      <canvas ref={orbCanvasRef} className="orb-umbilical-orb" />
    </div>
    </>
  );
};

export default LaptopHero;
